module.exports = __webpack_public_path__ + "static/media/BannerD11.fe6476ec.png";